import React, { Component } from 'react';
import {
    BackTop,
    message,
    notification,
    Button,
    Table,
    Menu,
    Space,
    Select,
    Tag,
    Row,
    Col,
    Card,
    DatePicker,
    Input,
    Tooltip,
    Typography,
    Tabs,
    Avatar,
    Modal,
    Divider
} from 'antd'

import {
    PlusOutlined,
    MinusOutlined,
    ReloadOutlined,
    ClockCircleOutlined,
    CloseOutlined,
    DownOutlined,
    PrinterOutlined
} from '@ant-design/icons';

import Re, { Link, Redirect } from 'react-router-dom';

import { toJS, _getAdministration } from "mobx";
import { inject, observer } from 'mobx-react';

import _, { parseInt, times, conforms, filter } from 'lodash';
import moment from 'moment';
import { LoadingGlobal } from '../components/LoadingGlobal';
//moment.locale('tr')
//import 'moment/locale/tr';

//import { openNotification } from "../components/Notification"

import ReactToPrint from "react-to-print";
import NavbarMenu from '../components/NavbarMenu';
import ComponentToPrint from '../components/ToPrint';

import Iframe from 'react-iframe'
import Frame from 'react-frame-component';
import axios from 'axios';
import { formatMyMoney } from '../helper';

const { TabPane } = Tabs;

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, } = Typography;
const { SubMenu } = Menu;

@inject('HourseBetStore', 'UserStore')
@observer
export default class HourseBet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            modalVisible: false,
            modalOpenCreate: false,

            nowDate: Date.now(),
            selectedRaceIn: null,
            selectedKosu: null,
            raceData: [],
            showGanyanDropdownList: false,
            bahisler: null,
            selectedBahis: null,
            couponContent: { cols: { run: 3, horse: [] } },
            runs: [],
            selectedRun: null,
            selectedDataV1: null,
            much: 1,
            hourseDetailHtml: '',
            jokeyDedailHtml: ''
        }

    }


    componentDidMount() {
        this.interval = setInterval(() => {
            this.intervalFunc()
        }, 50000);

        this.getItems()


        /*
        document
            .querySelector("iframe")
            .contentWindow.document.querySelector("h1#firstHeading").style.color =
            "red";
            */

    }

    onClickHourseName = (v) => {
        console.log({ v })

        this.getHourseInServer(v.KOD)
    }
    onClickJokeyDetail = (v) => {
        console.log("onClickJokeyDetail", { v })
        // JOKEYKODU
        this.getJokeyInServer(v.JOKEYKODU)
    }


    getHourseInServer = (kod) => {
        const url = `https://www.tjk.org/TR/YarisSever/Query/ConnectedPage/AtKosuBilgileri?1=1&QueryParameter_AtId=${kod}`
        axios.get(url)
            .then(res => {
                this.setState({ hourseDetailHtml: res.data }, () => {
                    this.setState({ modalVisible: true })
                })
            })
    }

    getJokeyInServer = (kod) => {
        const url = ` https://www.tjk.org/TR/YarisSever/Query/Page/JokeyIstatistikleri?1=1&QueryParameter_JokeyId=${kod}`
        axios.get(url)
            .then(res => {
                this.setState({ jokeyDedailHtml: res.data }, () => {
                    this.setState({ modalVisible: true })
                })
            })
    }

    onClickCancelModal = () => {
        this.setState({ modalVisible: false, hourseDetailHtml: '', jokeyDedailHtml: '' })
    }



    intervalFunc = () => {
        this.setState({ nowDate: Date.now() })
        // this.setState({ data: [] })
        /*
                const data = this.state.data
        
                let changed = false
        
                data.map((v, i) => {
                    _.get(v, "kosular", []).map((run, i) => {
                        const moment1 = moment(`${_.get(run, "TARIH")} ${_.get(run, "SAAT")}`, "DD/MM/YYYY H:mm")
                        const nowDate = new Date()
                        const runDate = new Date(moment1.toDate())
                        //  runDate.setMinutes(runDate.getMinutes() - 1)
                        if (nowDate >= runDate) {
                            changed = true
                            const fI = v.kosular.findIndex(v => v.KOD == run.KOD)
                            if (fI != -1) {
                                v.kosular.splice(fI, 1);
                            }
        
                        }
                    })
                })
        
                if (changed) {
                    this.setState({ data: this.state.data }, () => {
                        this.initSelectedData()
                    })
                }
        */

    }



    componentWillUnmount() {
        clearInterval(this.interval);
        //  this.componentRef = null
    }
    initSelectedData = () => {
        const data = _.get(this.state, "data", [])
        if (data.length > 0) {




            const bahisler1st = _.find(this.state.bahisler.hippodromes, (o) => {
                return _.get(o, "data.SIRA") === "1"
            })
            if (bahisler1st) {
                const KEY = bahisler1st.value
                const firstDataItem = _.find(data, { KEY })
                firstDataItem.selected = true
                firstDataItem.kosular[0].selected = true
                this.setState({ data, selectedDataV1: firstDataItem })
            }
            else {
                const firstDataItem = data[0]
                firstDataItem.selected = true
                firstDataItem.kosular[0].selected = true
                this.setState({ data, selectedDataV1: firstDataItem })
            }
            //KEY

            //       console.log("**", { bahisler1st, bahisler: this.state.bahisler, data })

            this.initBahisler()
        }

    }

    //itemleri getir (init)
    getItems = async () => {
        this.setState({ loading: true })
        try {
            const serverData = await this.props.HourseBetStore.getmainDataInServerV2()
            let data = _.get(serverData, "data.program", [])
            let bahisler = _.get(serverData, "data.bahisler.hippodromes", [])
            console.log("1111", { serverData })
            this.setState({ data, bahisler: _.get(serverData, "data.bahisler") })
            this.initSelectedData()

            console.log({ bahisler })

            /*
            bahisler.map(v => {
                const key = v.value // il(bölge) keyi
                v.types.map(v => {
                    //eğer ikili bahisse
                    if (v.value == "ikili_bahis") {
                        v.races.map((v, i) => {
                            v.array.push(`${v.value}-value`)
                            let fData = _.find(data, { KEY: key })
                            let fKosu = _.find(_.get(fData, "kosular", []), { NO: v.value })
                            if (fKosu) {
                                fKosu.NO = `${v.value}-value`
                                fData.kosular.push(fKosu)
                            }
                        })
                    }
                    else {
                        v.races.map((v, i) => {
                            v.array.push(`${v.value}-value`)
                            let fData = _.find(data, { KEY: key })
                            let fKosu = _.find(_.get(fData, "kosular", []), { NO: v.value })
                            if (fKosu) {
                                fData.kosular.push(fKosu)
                                fKosu.NO = `${v.value}-value`
                            }
                        })
                    }
                })
            })
            */




            //  this.setSpecialBetClonned()

            if (data.length == 0) {
                // this.getItems()
            }
        } catch (error) {
            const statusCode = _.get(error, "response.status")
            if (statusCode == 404) {
                this.setState({ statusCode })
            }
            console.log({ error, statusCode })
            //  this.getItems()
        }
        finally {
            this.setState({ loading: false })
        }
    }


    //yüklendikten sonra ilk dataların seçili hale gelmesi (bahisler,koşular - uygun olanlar)
    initBahisler = () => {
        const types = _.get(this.findBahis(), "types", [])
        //önce 6 lı ganyanı bul (sırasıyla uygun olanları bulup ceçili hale getir)
        const f6li = _.find(types, { value: "6_li_ganyan" })
        const f5li = _.find(types, { value: "5_li_ganyan" })
        const f4lu = _.find(types, { value: "4_lu_ganyan" })
        const f3lu = _.find(types, { value: "3_lu_ganyan" })
        const f2li = _.find(types, { value: "ikili_bahis" })
        if (f6li) {
            const selectedBahis = f6li
            selectedBahis.children = selectedBahis.races[0]
            this.afterİnitBahis(selectedBahis)
        }
        else if (f5li) {
            const selectedBahis = f5li
            selectedBahis.children = selectedBahis.races[0]
            this.afterİnitBahis(selectedBahis)
        }
        else if (f4lu) {
            const selectedBahis = f4lu
            selectedBahis.children = selectedBahis.races[0]
            this.afterİnitBahis(selectedBahis)
        }
        else if (f3lu) {
            const selectedBahis = f3lu
            selectedBahis.children = selectedBahis.races[0]
            this.afterİnitBahis(selectedBahis)
        }
        else if (f2li) {
            const selectedBahis = f2li
            selectedBahis.children = selectedBahis.races[0]
            this.afterİnitBahis(selectedBahis)
        }
        else {
            const selectedBahis = types[0]
            if (selectedBahis) {
                selectedBahis.children = selectedBahis.races[0]
                this.afterİnitBahis(selectedBahis)
            }
        }
    }

    afterİnitBahis = (selectedBahis) => {
        if (selectedBahis) {
            this.setState({ selectedBahis }, () => {
                this.initSelectKosular()
                this.setSpecialBetClonned()
            })
        }

        let selectedDataV1 = this.state.selectedDataV1
        let kosular = _.get(selectedDataV1, "kosular", [])
        // selectedDataV1.kosular[9] = kosular[1]
        let abcRun = Object.assign({}, kosular[8])
        abcRun.NO = "123"
        //  _.unset(abcRun,"NO")
        let newObj = {
            run1: kosular[8],
            run2: abcRun
        }
        //  newObj.run1.NO="00000"
        selectedDataV1.kosular.push(abcRun)
        this.setState({ runs: kosular })

        console.log("------------------------------//////////////////////////", { newObj })

    }

    //ikili ve tabela bahisleri ayarla
    setSpecialBetClonned = () => {
        let bahisler = _.get(this.state, "bahisler.hippodromes", []);
        let data = _.get(this.state, "data", []);
        bahisler.map(v => {
            const key = v.value // il(bölge) keyi
            v.types.map(v => {
                //eğer ikili bahisse
                if (v.value == "ikili_bahis") {
                    v.races.map((v, i) => {
                        const constable = `${v.value}-ikili`
                        //  const fI = _.findIndex(v.array,`${v.value}-value`)
                        if (!_.includes(v.array, constable)) {
                            v.array.push(constable)
                        }

                        let fData = _.find(data, { KEY: key })
                        let fKosu1 = _.find(_.get(fData, "kosular", []), { NO: v.value })
                        let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                        //  let fKosu2 = Object.assign({}, fKosu1)
                        if (fKosu2) {
                            fKosu2.NO = constable
                            fKosu1.title = `1.At`
                            fKosu2.title = `2.At`
                            const f = _.find(_.get(fData, "kosular", []), { NO: constable })
                            if (!f) {
                                fData.kosular.push(fKosu2)

                            }

                        }
                    })
                }

                //eğer sıralı ikili bahisse
                if (v.value == "sirali_ikili_bahis") {
                    v.races.map((v, i) => {
                        const constable = `${v.value}-sirali-ikili`
                        //  const fI = _.findIndex(v.array,`${v.value}-value`)
                        if (!_.includes(v.array, constable)) {
                            v.array.push(constable)
                        }

                        let fData = _.find(data, { KEY: key })
                        let fKosu1 = _.find(_.get(fData, "kosular", []), { NO: v.value })
                        let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                        //  let fKosu2 = Object.assign({}, fKosu1)
                        if (fKosu2) {
                            fKosu2.NO = constable
                            fKosu1.title = `1.At`
                            fKosu2.title = `2.At`
                            const f = _.find(_.get(fData, "kosular", []), { NO: constable })
                            if (!f) {
                                fData.kosular.push(fKosu2)

                            }

                        }
                    })
                }

                if (v.value == "sirali_uclu_bahis") {
                    let fData = _.find(data, { KEY: key })
                    v.races.map((v, i) => {
                        let fKosu1 = _.find(_.get(fData, "kosular", []), { NO: v.value })
                        fKosu1.title = `1.At`
                        for (let index = 1; index < 3; index++) {
                            const constable = `${v.value}-sirali-uclu-bahis-${index}`
                            if (!_.includes(v.array, constable)) {
                                v.array.push(constable)
                            }
                            let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                            if (fKosu2) {

                                fKosu2.title = `${index + 1}.At`
                                fKosu2.NO = constable
                                const f = _.find(_.get(fData, "kosular", []), { NO: constable })
                                if (!f) {
                                    fData.kosular.push(fKosu2)
                                }
                            }
                        }


                        /*
                        const constable = `${v.value}-sirali-uclu-bahis`
                        if (!_.includes(v.array, constable)) {
                            v.array.push(constable)
                        }

                        let fData = _.find(data, { KEY: key })
                        let fKosu1 = _.find(_.get(fData, "kosular", []), { NO: v.value })
                        let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                        let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                        //  let fKosu2 = Object.assign({}, fKosu1)
                        if (fKosu2) {
                            fKosu2.NO = constable
                            fKosu1.title = `1.At`
                            fKosu2.title = `2.At`
                            fKosu2.title = `2.At`
                            const f = _.find(_.get(fData, "kosular", []), { NO: constable })
                            if (!f) {
                                fData.kosular.push(fKosu2)

                            }

                        }
                        */
                    })
                }



                if (v.value == "tabela_bahis") {
                    let fData = _.find(data, { KEY: key })
                    v.races.map((v, i) => {

                        let fKosu1 = _.find(_.get(fData, "kosular", []), { NO: v.value })
                        fKosu1.title = `1.At`
                        for (let index = 1; index < 4; index++) {
                            const constable = `${v.value}-tabela-${index}`
                            if (!_.includes(v.array, constable)) {
                                v.array.push(constable)
                            }

                            let fKosu2 = JSON.parse(JSON.stringify(fKosu1))
                            if (fKosu2) {

                                fKosu2.title = `${index + 1}.At`
                                fKosu2.NO = constable
                                const f = _.find(_.get(fData, "kosular", []), { NO: constable })
                                if (!f) {
                                    fData.kosular.push(fKosu2)
                                }
                            }
                        }
                    })

                }
            })
        })
        // this.setState({selectedBahis})

        console.log("///////////////", { bahisler, data })
        /*
                const kosular = _.get(this.getSelectedData(), "kosular", [])
                const c1 = this.getSelectedKosu()
                const c2 = _.clone(c1)
                c1.title = "1.At"
                c2.title = "2.At"
                c2.NO = "120"
                const selectedDataRuns = [c1, c2]
                let myBahis = this.state.selectedBahis;
                myBahis.children.array.push("120")
                this.setState({ selectedBahis: myBahis })
                const mData = this.getSelectedData()
                mData.kosular.push(c2)
                this.setState({ data: this.state.data })
                console.log("///////////////////////--- ikili bahis ---/////", { c1, c2, mData,kosular,selectedDataRuns })
        */

    }

    // ko0şuları mantıklı bir şekilde seç
    initSelectKosular = () => {
        //klonlama olayı
        const runArray = _.get(this.state.selectedBahis, "children.array", [])[0]
        console.log({ runArray, b: this.state.selectedBahis })
        this.onClickTabKosu({ NO: runArray.toString() })
    }


    //koşular tıklandığında (TAB)
    onClickTabKosu = (item, obj) => {
        // onClick={() => { this.onClickTabKosu({ NO: `${v.NO}-1at` }) }}
        const selectedBahis = this.state.selectedBahis
        const value = _.get(selectedBahis, "value", "")
        console.log("onClickTabKosu", { item, value })



        const fData = _.find(_.get(this.getSelectedData(), "kosular", []), (o) => {
            return o.NO === item.NO
        })
        if (fData) {

            _.get(this.getSelectedData(), "kosular", []).map(v => { v.selected = false }) // tüm koşuların seçili durumunu false yap
            fData.selected = true
            this.setState({ data: this.state.data })
        }
        console.log({ selectedBahis, item })

    }






    //ilgili bölgenin bahisini getir
    findBahis = () => {
        const hippodromes = _.get(this.state.bahisler, "hippodromes", [])
        const getSelectedData = this.getSelectedData()
        return _.find(hippodromes, { value: _.get(getSelectedData, "KEY") })
    }



    //hiponrom yeri tıklandığında
    onClickHipodromArea = (item) => {

        this.setState({ selectedDataV1: item })
        const { data } = this.state
        data.map(v => { v.selected = false })
        let selectedItem = _.find(data, (o) => {
            return _.get(o, "hava.HIPODROMYERI", "") === _.get(item, "hava.HIPODROMYERI", "")
        })
        //eğer seçili item varsa
        if (selectedItem) {
            selectedItem.selected = true
            const isSelectedRun = _.find(_.get(selectedItem, "kosular", []), { selected: true })
            //eğer seçilen hiponromun seçili koşusu yoksa, seçili hale getir
            if (!isSelectedRun) {
                const firstRun = _.get(selectedItem, "kosular", [])
                if (firstRun.length > 0) {
                    firstRun[0].selected = true
                }
            }
            this.setState({ data: this.state.data }, () => {
                this.initBahisler()
                //  this.getItems()
            })
        }
    }

    //seçili data
    getSelectedData = () => {
        const { data } = this.state
        return _.find(data, { selected: true })
    }

    //seçili koşu
    getSelectedKosu = () => {
        return _.find(_.get(this.getSelectedData(), "kosular", []), { selected: true })
    }


    //seçili koşu field ini getir
    getSelectedKosuField = (fieldName) => {
        return _.get(this.getSelectedKosu(), fieldName, "")
    }

    ///   #########
    //tüm koşuların atlarını getir
    getAtlarWithKosu = (i) => {
        const kactan = i
        //  return _.get(this.getSelectedData(), "kosular", [])[kactan]
        return _.find(_.get(this.getSelectedData(), "kosular", []), { NO: kactan.toString() })
    }
    //  #### at seç .( COUPON)
    selectHourse = (runNo = null, v) => {
        if (!runNo) {
            runNo = _.get(this.getSelectedKosu(), "NO")
        }
        const hourseNo = v.NO
        const run = _.find(_.get(this.getSelectedData(), "kosular", []), { NO: runNo })
        v.selected = !v.selected
        if (v.KOSMAZ) {
            v.selected = false
        }
        //  this.setState({ data: this.state })

        //koşular tablosunda ilgili koşoyu tetikledil
        this.onClickTabKosu({ NO: runNo })
        console.log(v)

        //ilgili atı seç
        // this.getSelectedData()
        //  _.get(this.getAtlarWithKosu(index), "atlar", []).map((v, i) => {}

    }

    onClickHandikap = (v, i) => {
        //v = NO (int)    i = index
        //v.toString()

        if (typeof v == "number") {
            v = v.toString()
        }


        this.onClickTabKosu({ NO: v })

        const hourses = _.get(this.getSelectedKosu(), "atlar")
        // const hourses =_.find(_.get(this.getSelectedData(), "kosular",[]),{NO:v})  


        const selectedHourses = _.filter(hourses, (o) => {
            return o.selected && !o.KOSMAZ
        })

        const unSelectedHourses = _.filter(hourses, (o) => {
            return !o.selected && !o.KOSMAZ
        })


        if (selectedHourses.length > unSelectedHourses.length) {
            selectedHourses.map(v => { v.selected = false })
        }
        else if (selectedHourses.length < unSelectedHourses.length) {
            unSelectedHourses.map(v => { v.selected = true })
        }
        else {
            selectedHourses.map(v => { v.selected = false })
        }


        console.log({ v, i, selectedHourses, unSelectedHourses })

        this.setState({ data: this.state.data })
    }

    //max agf getir
    getMaxAgfValue = (indexRun = null) => {

        //maximum değer
        const maxxAgf = _.maxBy(_.get(indexRun ? this.getAtlarWithKosu(indexRun) : this.getSelectedKosu(), "atlar", []), (o) => {
            return parseInt(o.AGF1)
        })
        return _.get(maxxAgf, "KEY")
    }


    /******AGA */
    //seçili datanın bahisleri
    getSelectedDataBet = () => {
        const data = this.getSelectedData()
        const bahisler = _.find(_.get(this.state.bahisler, "hippodromes"), (o) => {
            return o.value === _.get(data, "KEY")
        })
        return bahisler
    }




    // bahisler butonu tıklandığında
    onClickBetMenu = (item) => {
        console.log("onClickBetMenu", { item })
        item.children = item.races[0]
        // this.setState({ selectedBahis: item })
        this.afterİnitBahis(item)
    }
    onClickBetMenuChildren = (item) => {
        console.log("onClickBetMenuChildren", { item })
        this.state.selectedBahis.children = item
        //  this.setState({ selectedBahis: this.state.selectedBahis })
        this.afterİnitBahis(this.state.selectedBahis)
    }

    //Bahis tutarı getir
    betCount = () => {
        const array = _.get(this.state.selectedBahis, "children.array", []);
        let i = 1
        array.map(v => {
            if (typeof v == "number") {
                v = v.toString()
            }
            const run = _.find(_.get(this.getSelectedData(), "kosular", []), { NO: v })
            const selectedHourseCount = _.filter(_.get(run, "atlar", []), { selected: true }).length
            i = i * selectedHourseCount
        })
        return i
    }
    //kupon tutarını getir
    getPrice = (isFormated = true) => {
        const { selectedBahis } = this.state
        const avaiableBahisler = this.props.HourseBetStore.avaiableBahisler;
        let much = parseInt(this.state.much)
        const betCount = this.betCount()
        const selectedValue = _.get(selectedBahis, "value")
        const sAvaiableBahisler = _.find(avaiableBahisler, { value: selectedValue })
        let monadPrice = _.get(sAvaiableBahisler, "aprice", 1)
        const dAvaiable = _.find(_.get(sAvaiableBahisler, "group.a", []), (o) => {
            return _.includes(o, _.get(this.getSelectedData(), "KEY", ""))
        })

        console.log({ avaiableBahisler: toJS(avaiableBahisler), sAvaiableBahisler: toJS(sAvaiableBahisler), dAvaiable, key: _.get(this.getSelectedData(), "KEY", "") })
        if (dAvaiable) {
            monadPrice = _.get(sAvaiableBahisler, "group.aprice", 1)
            // monadPrice = _.get(dAvaiable, "aprice", 1)
        }
        if (typeof much != "number" || isNaN(much)) {
            much = 1
        }
        return isFormated ? this.formatMyMoney(much * betCount * monadPrice) : much * betCount * monadPrice
    }
    formatMyMoney = (price) => {

        var currency_symbol = "₺"

        var formattedOutput = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 2,
        });

        return formattedOutput.format(price).replace(currency_symbol, '')
    }

    //kuponun içindeki atlar seçili mi  (kupon oynamaya uygun mu?)
    selectedMinHourseInRuns = () => {
        const { minCouponPrice } = this.props.HourseBetStore
        //eğer kupon tutarı 2 den küçükse kabul etme.
        if (this.getPrice(false) < minCouponPrice) {
            return false
        }
        const array = _.get(this.state.selectedBahis, "children.array", []);
        let i = 0
        array.map(v => {
            if (typeof v == "number") {
                v = v.toString()
            }
            const run = _.find(_.get(this.getSelectedData(), "kosular", []), { NO: v })
            if (_.filter(_.get(run, "atlar", []), { selected: true }).length > 0) {
                i++
            }
        })
        return i == array.length ? true : false
    }

    //kupondaki atları getir
    getSelectedHourseInRuns = () => {
        const array = _.get(this.state.selectedBahis, "children.array", []);
        let temp = []
        array.map(v => {
            if (typeof v == "number") {
                v = v.toString()
            }
            const run = _.find(_.get(this.getSelectedData(), "kosular", []), { NO: v })
            console.log({ run })
            if (run) {
                let pushData = {
                    ...run,
                    atlar: _.filter(_.get(run, "atlar", []), { selected: true })
                }
                temp.push(pushData)
                console.log({ pushData })
            }
        })
        return temp
    }

    //kupon kayıttan önceki kontroller
    beforeSaveCoupon = () => {
        const errors = []

        const { maxCouponPrice } = this.props.HourseBetStore

        if (this.getPrice(false) > maxCouponPrice) {
            errors.push(`Kupon değeri ${maxCouponPrice} değerinden küçük olmalı!`)
        }

        const array = _.get(this.state.selectedBahis, "children.array", []);
        array.map(v => {
            if (typeof v == "number") {
                v = v.toString()
            }
            const run = _.find(_.get(this.getSelectedData(), "kosular", []), { NO: v })
            console.log({ run })
            if (run) {
                const moment1 = moment(`${_.get(run, "TARIH")} ${_.get(run, "SAAT")}`, "DD/MM/YYYY H:mm")
                const nowDate = new Date()
                const runDate = new Date(moment1.toDate())
                runDate.setMinutes(runDate.getMinutes() - 1)
                if (nowDate >= runDate) {
                    errors.push("Başlamış koşuya bahis yapılamaz!")
                }
            }
        })
        //kullanıcı bakiye kontrolü
        const userBalance = _.get(this.props.UserStore.user, "balance", 0)
        if (this.getPrice(false) > userBalance) {
            errors.push(`Kupon tutarı ${formatMyMoney(userBalance)} ₺ den büyük olamaz!`)
        }
        return errors.length > 0 ? _.join(errors, ",") : false

    }

    //# kuponu kaydet (OYNA)
    onClickSaveCoupon = () => {

        const userBalance = _.get(this.props.UserStore.user, "balance", 0)
        console.log(userBalance)

        const isAvaiable = this.selectedMinHourseInRuns()
        if (!isAvaiable) {
            console.log("Kupon oynamaya uygun değil")
            return
        }

        //kuponu göndermeden önceki kontroller
        if (this.beforeSaveCoupon()) {
            message.warning(this.beforeSaveCoupon())
            return
        }





        const { much, selectedBahis } = this.state
        const betCount = this.betCount()
        const price = this.getPrice(false)
        const priceFormated = this.getPrice()
        const runs = this.getSelectedHourseInRuns()
        const nowDate = new Date()
        const selectedDataBet = this.getSelectedDataBet()
        const selectedData = this.getSelectedData()

        let toServerData = {
            much,
            selectedBahis,
            betCount,
            price,
            priceFormated,
            runs,
            nowDate,
            content: {
                data: _.get(selectedDataBet, "data", {}),
                agf: _.get(selectedData, "agf", {})
            },
            text: _.get(selectedDataBet, "text"),
            value: _.get(selectedDataBet, "value")
        }

        this.saveCouponService(toServerData)


    }

    saveCouponService = async (data) => {
        this.setState({ loading: true })
        try {
            const serverData = await this.props.HourseBetStore.saveCoupon(data)
            console.log("saveCouponService serverData", serverData)
            this.onClickClearCoupon()
            const newBalance = _.get(serverData, "balance", 0)
            this.props.UserStore.setUserBalance(newBalance)

            serverData.user = this.props.UserStore.user

            let coupons = _.get(this.props.HourseBetStore, "coupons", [])
            if (coupons.length > 0) {
                this.props.HourseBetStore.push(serverData)
            }

            console.log("saveCouponService", { serverData })

            this.showNotification("Başarılı", `Kupon oluşturuldu. Kalan bakiyeniz: ${formatMyMoney(newBalance)} (${_.get(serverData, "title", "")})`, 5, "success", serverData)
        } catch (error) {
            console.log({ error })
            message.error(_.get(error, "response.data.message", ""))
        }
        finally {
            this.setState({ loading: false })
        }
    }

    showNotification = (message, description, duration, type = "info", record) => {
        const key = `open${Date.now()}`;
        const btn = (
            <span>
                <ReactToPrint
                    trigger={() => {
                        return <Button
                            onMouseOver={() => this.setState({ coupon: record })}
                            size="small" type="primary" title="Yazdır"
                            icon={<PrinterOutlined />}>Yazdır</Button>
                    }}
                    content={() => this.componentRef}

                >
                </ReactToPrint>

                <Divider type="vertical" />

                <Button type="default" size="small"
                    onClick={() => this.setState({ Redirect: "/panel/user/coupon" })}
                >
                    Kupon Listesi
              </Button>
                <Divider type="vertical" />
                <Button type="default" size="small" onClick={() => notification.close(key)}>
                    Kapat
              </Button>
            </span>
        );

        notification.open({
            message,
            description,
            btn,
            key,
            onClose: notification.close(key),
            duration,
            type
        });

    }

    //kuponu temizle
    onClickClearCoupon = () => {
        const runs = _.get(this.getSelectedData(), "kosular", [])
        runs.map(item => {
            const hourses = _.get(item, "atlar")
            hourses.map(v => { v.selected = false })
        })
        this.setState({ data: this.state.data, much: 1 })
    }



    render() {
        const { data, loading, nowDate, statusCode } = this.state

        const avaiableBahisler = this.props.HourseBetStore.avaiableBahisler;



        const cCouponItems = []

        /*
    
         <div key={i} className="clas1"
                                    style={{width:"24px", height:"24px", backgroundColor:"red", borderRadius:5,zIndex:6}}
                                    onClick={() => this.selectHourse(index.toString(), v.NO)}
                                >
                                    <div  className="clas2" style={{width:"23px", height:"23px", color:"white"}}
                                        title={v.AD}
                                    >
                                       {v.NO}
                                    </div>
                                </div>
    
    
    
                                        <div key={i}
                                    onClick={() => this.selectHourse(index.toString(), v.NO)}
                                    className="d-block text-center bet-checkbox checkbox-color-default at-selected" >
                                    <div className="custom-control custom-checkbox at-selected"
                                        title={v.AD}
                                    >
                                        <label className="custom-control-label at-selected"
                                            data-no={v.NO} />
                                    </div>
                                </div>
            */



        /*
    
    for (let index = 1; index <= _.get(_.find(ganyanList, { selected: true }), "count", 6); index++) {
        cCouponItems.push(
            <td style={{ zIndex: 8 }} key={index} className="align-top">
                {
                    _.get(this.getAtlarWithKosu(index), "atlar", []).map((v, i) => {
                        let activeClass = ""
                        if (v.selected) activeClass = "hb-c-default-selected"
    
                        //maximum değer
                        const maxxAgf = _.maxBy(_.get(this.getAtlarWithKosu(index), "atlar", []), (o) => {
                            return parseInt(o.AGF1)
                        })
                        ////console.log({maxxAgf})
                        //  if()   parseInt(o.AGF1)==parseInt(v.AGF1)
                        if (_.get(maxxAgf, "NO") == v.NO) activeClass = `${activeClass} hb-c-agf`
                        if ((_.get(maxxAgf, "NO") == v.NO) && v.selected) activeClass = `${activeClass} hb-c-agf-selected`
    
                        if (v.KOSMAZ) activeClass = `${activeClass} hb-c-kosmez`
    
                        return (
                            <div key={i}
                                className={
                                    `clas1 hb-c-default ${activeClass}`
                                }
                                onClick={() => this.selectHourse(index.toString(), v)}
                            >
                                <div className="clas2 "
                                    title={v.AD}
                                >
                                    {v.NO}
                                    {
                                        //   maxxAgf
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </td>
        )
    
     
    }
    */




        {


            _.get(this.getSelectedData(), "kosular", []).
                map((run, index) => {
                    if (
                        _.includes(_.get(this.state.selectedBahis, "children.array", []), Number(run.NO))
                        ||
                        _.includes(_.get(this.state.selectedBahis, "children.array", []), run.NO)
                    ) {

                        cCouponItems.push(
                            <td style={{ zIndex: 8 }} key={index} className="align-top">
                                {
                                    _.get(this.getAtlarWithKosu(run.NO), "atlar", []).map((v, i) => {
                                        let activeClass = ""
                                        if (v.selected) activeClass = "hb-c-default-selected"
                                        if (v.KOSMAZ) activeClass = `${activeClass} hb-c-kosmez`
                                        if (v.AGF1COLOR || v.AGF2COLOR) activeClass = `${activeClass}hb-c-agf`
                                        if ((v.AGF1COLOR || v.AGF2COLOR) && v.selected) activeClass = `${activeClass} hb-c-agf-selected`

                                        return (
                                            <div key={i}
                                                className={
                                                    `clas1 hb-c-default ${activeClass}`
                                                }
                                                onClick={() => this.selectHourse(run.NO, v)}
                                            >
                                                <div className="clas2"
                                                    title={v.AD}
                                                >
                                                    {v.NO}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </td>
                        )

                    }
                })


        }





        if (statusCode != 404) {
            return (
                <div
                >
                    <LoadingGlobal loading={loading} />

                    {
                        this.state.Redirect
                        &&
                        <Redirect to={this.state.Redirect} />
                    }

                    <main>
                        {/* Bahiis Yap */}
                        <main>
                            <NavbarMenu />
                            <div className="row no-gutters">
                                <div className="col-2">

                                </div>

                                <div className="col">
                                    <div style={{ marginLeft: '-15px', color: '#FFF', padding: '2px' }}>
                                        <div className="p-2 bg-black text-white p13">
                                            <span className="font-xsm font-weight-normal mr-3">
                                                <strong>Sıcaklık</strong>:
                                            {_.get(this.getSelectedData(), "hava.SICAKLIK", "")}°C
          &nbsp;
                        <strong>Nem</strong>: {`${_.get(this.getSelectedData(), "hava.NEM", "")}% `}
                                                {`${_.get(this.getSelectedData(), "hava.HAVA_TR", "")}`}
                                            </span>
                                            <span className="font-xsm font-weight-normal">
                                                <strong>Çim</strong>:
            {`${_.get(this.getSelectedData(), "hava.CIM_TR", "")}  `}
                                                {`${_.get(this.getSelectedData(), "hava.CIMPISTAGIRLIGI", "")}`}
          &nbsp;&nbsp;
          <strong>Kum</strong>:
          {`${_.get(this.getSelectedData(), "hava.KUM_TR", "")}`}
                                            </span>
                                            <span data-bet-server-timer className="float-right font-xsm font-weight-normal opacity-08">
                                                {new Date().getDate()}
                                                {` `}
                                                {moment(new Date()).format("MMMM")}
                                                {` `}
                                                {moment(new Date()).format("dddd")}
                                                {` `}
                                                {` ${new Date(nowDate).getHours()}:${new Date(nowDate).getMinutes()}`}
                                            </span>
                                        </div>

                                    </div>



                                    {/* Skor Tablo  */}


                                </div>

                            </div>

                            <div className="row" data-page="bet-page" style={{ width: '100%' }}>
                                <div className="col-2">

                                    <div className="row no-gutters mb-3" >
                                        {
                                            data.map((v, i) => {
                                                return (
                                                    <div key={i} className="col-6">
                                                        <a
                                                            onClick={() => this.onClickHipodromArea(v)}
                                                            className={`btn btn-glossred  w-100 rounded-0 ${v.selected ? "selected-ganyan-title" : ""}`}>
                                                            {_.get(v, "hava.HIPODROMYERI", "")}
                                                        </a>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        _.filter(_.get(this.getSelectedDataBet(), "types", []), (o => {
                                            return _.find(avaiableBahisler, { value: o.value }) ? true : false

                                        })).
                                            map((v, i) => {
                                                return (
                                                    <ul key={i} className="a-container">
                                                        <li
                                                            className="a-items">
                                                            <input type="radio"
                                                                onChange={(e) => console.log(e.target.checked)}
                                                                checked={_.get(this.state.selectedBahis, "value") === v.value}
                                                                onClick={() => this.onClickBetMenu(v)}
                                                                name="ac" id={`a${i}`} />
                                                            <label htmlFor={`a${i}`}>
                                                                {v.text}
                                                            </label>
                                                            <div className="a-content">
                                                                {
                                                                    _.get(v, "races", []).map((v, i) => {
                                                                        return (
                                                                            <div
                                                                                onClick={() => this.onClickBetMenuChildren(v)}
                                                                                key={i} className={`sMenuBtn ${_.get(this.state.selectedBahis, "children.value") == v.value ? "sMenuBtnSelect" : "sMenuBtnDefault"}`}>
                                                                                {v.text}
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </li>
                                                    </ul>
                                                )
                                            })
                                    }
                                </div>

                                <div className="col-8 card w-100 mb-3 border-0 rounded-0 " data-panel-id="bet-table" data-selector="betContent">
                                    <div className="card-body p-0 bet-table-container" data-selector="bet-table-container">
                                        <nav className="m-0">
                                            <div className="nav nav-tabs bet-tab" role="tablist" data-selector="raceTabs">
                                                {

                                                    _.get(this.getSelectedData(), "kosular", []).
                                                        //  _.get(this.state.selectedBahis,"children.array",[]).
                                                        map((v, i) => {
                                                            if (_.includes(_.get(this.state.selectedBahis, "children.array", []), Number(v.NO))) {
                                                                return (
                                                                    <a key={i}
                                                                        onClick={() => { this.onClickTabKosu(v) }}
                                                                        className={`nav-item nav-link border-0 tabcolor-${_.get(v, "ActiveClass", "")} font-sm ${v.selected ? "active" : ""}`}>
                                                                        {v.NO}.Koşu

                                                                    </a>
                                                                )
                                                            }
                                                            else if (_.includes(_.get(this.state.selectedBahis, "children.array", []), v.NO)) {
                                                                //ikili ise
                                                                if (
                                                                    (_.get(this.state.selectedBahis, "value") == "ikili_bahis")
                                                                    ||
                                                                    _.get(this.state.selectedBahis, "value") == "sirali_ikili_bahis"
                                                                    ||
                                                                    _.get(this.state.selectedBahis, "value") == "sirali_uclu_bahis"
                                                                ) {
                                                                    return (
                                                                        <a key={i}
                                                                            // onClick={() => { this.onClickTabKosu(v, { type: "ikili_bahis", hourse: 1 }) }}
                                                                            onClick={() => { this.onClickTabKosu(v) }}
                                                                            className={`nav-item nav-link border-0 tabcolor-${_.get(v, "ActiveClass", "")} font-sm ${v.selected ? "active" : ""}`}>
                                                                            {v.title}

                                                                        </a>

                                                                    )
                                                                }
                                                                //tabela ise
                                                                if (_.get(this.state.selectedBahis, "value") == "tabela_bahis") {
                                                                    return (
                                                                        <a key={i}
                                                                            // onClick={() => { this.onClickTabKosu(v, { type: "ikili_bahis", hourse: 1 }) }}
                                                                            onClick={() => { this.onClickTabKosu(v) }}
                                                                            className={`nav-item nav-link border-0 tabcolor-${_.get(v, "ActiveClass", "")} font-sm ${v.selected ? "active" : ""}`}>
                                                                            {v.title}

                                                                        </a>
                                                                    )
                                                                }
                                                            }
                                                            else {
                                                                return (<div key={i} />)
                                                            }
                                                        })
                                                }


                                            </div>
                                        </nav>
                                        <div className="tab-content bet-tabs" data-selector="betTableContainer">
                                            <div className="tab-pane fade show active" id="bet-1" role="tabpanel" aria-labelledby="bet-1-tab">
                                                <div className={`text-white bg-${_.get(this.getSelectedKosu(), "ActiveClass", "")}`}>
                                                    <div className="row p-2 pl-3 pr-3 no-gutters">
                                                        <div className="col col-11 font-xsm">
                                                            <span data-selector="allTabsShow"
                                                            //className="d-none"
                                                            >{this.getSelectedKosuField("RACENO")}.Koşu &nbsp;|&nbsp; </span>
                                                            {this.getSelectedKosuField("SAAT")}
                                                     &nbsp;|&nbsp; {`${this.getSelectedKosuField("MESAFE")} ${this.getSelectedKosuField("PISTADI_TR")}`} &nbsp;|&nbsp; {this.getSelectedKosuField("GRUP_TR")} &nbsp;|&nbsp;
                                                     {this.getSelectedKosuField("CINSDETAY_TR")}
                                                            <br />
                                                            <span className="text-white">
                                                                {this.getSelectedKosuField("ENIYIDERECEACIKLAMA")}
                                                            </span>
                                                        </div>
                                                        <div className="col text-right">
                                                            <a href="#" data-button-race-info={1}>
                                                                <i className="icon-info text-white" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="table-container bet-table">
                                                    <table className="table table-sm table-striped table-hover w-100">
                                                        <thead>
                                                            <tr className="text-truncate text-center font-xsm">
                                                                <th />
                                                                <th />
                                                                <th className="text-left">At İsmi</th>
                                                                <th>Yaş</th>
                                                                <th className="text-left px-0">Orijin (Baba-Anne)</th>
                                                                <th className="text-left">Kilo</th>
                                                                <th className="text-left">Jokey</th>
                                                                <th className="text-left px-0">Sahip/Antrenör</th>
                                                                <th>AGF</th>
                                                                <th>Son 6</th>
                                                                <th>St</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="selected-bg-sand">
                                                            {
                                                                _.get(this.getSelectedKosu(), "atlar", []).map((v, i) => {
                                                                    return (
                                                                        <tr key={i}
                                                                            onClick={() => this.selectHourse(null, v)}
                                                                            className={`text-truncate text-center selectable-horse ${_.get(v, "KOSMAZ", false) ? "disabled-horse" : ""} ${_.get(v, "selected", false) ? "selected" : ""}`} >
                                                                            <td className="bet-checkbox checkbox-color-default align-middle">
                                                                                {
                                                                                    v.KOSMAZ ?
                                                                                        <div>
                                                                                            <CloseOutlined style={{ color: 'red' }} />
                                                                                        </div>
                                                                                        :
                                                                                        <div className="custom-control custom-checkbox">
                                                                                            <label className={`custom-control-label ${v.selected ? "selected" : ""}`} data-no={v.NO} />
                                                                                        </div>
                                                                                }

                                                                            </td>
                                                                            <td>
                                                                                <div className="forma-img" style={{ backgroundImage: `url(${_.get(v, "FORMA", "").substring(29) ? `https://medya-cdn.tjk.org/formaftp/${_.get(v, "FORMA", "").substring(29)}` : "https://ebayi.tjk.org/dist/images/no-uniform.jpg"})` }} />
                                                                            </td>
                                                                            <td className="text-left font-weight-bold">
                                                                                <a className="text-dark hunderline" onClick={() => this.onClickHourseName(v)}>
                                                                                    <u className="text-decoration-none" >
                                                                                        {_.get(v, "AD", "")}
                                                                                        {` `}
                                                                                        {
                                                                                            !isNaN(parseInt(_.get(v, "EKURI", "")))
                                                                                            &&
                                                                                            <img src={`https://medya-cdn.tjk.org/imageftp/Img/e${_.get(v, "EKURI", "")}.gif`} />

                                                                                        }

                                                                                    </u></a>
                                                                                <br />
                                                                                <span className="text-red font-weight-normal font-xxsm" >{_.get(v, "TAKI", "")}</span>
                                                                            </td>
                                                                            <td className="align-middle font-xxsm">{_.get(v, "YAS", "")}</td>
                                                                            <td className="align-middle text-left font-xxsm px-0">
                                                                                <span className="text-blue" >{_.get(v, "BABA", "")}</span>
                                                                                <br />
                                                                                <span className="text-red" >{_.get(v, "ANNE", "")}</span>
                                                                                <span className="text-red" >{_.get(v, "ANNEBABA", "")}</span>
                                                                            </td><td className="align-middle text-left font-xxsm text-center">{_.get(v, "KILO", "")}</td>
                                                                            <td className="align-middle text-left font-xxsm">

                                                                                <span onClick={() => this.onClickJokeyDetail(v)} className="hunderline">{_.get(v, "JOKEYADI", "")}</span>
                                                                            </td>
                                                                            <td className="align-middle text-left px-0">
                                                                                <span className="font-xxsm" >{_.get(v, "SAHIPADI", "")}</span>
                                                                                <br />
                                                                                <span className="font-xxsm" >{_.get(v, "ANTRENORADI", "")}</span>
                                                                            </td>
                                                                            <td className="align-middle">
                                                                                {
                                                                                    v.AGF1
                                                                                        ?
                                                                                        <div className="agf-graph">
                                                                                            <div className={`agf ${v.AGF1COLOR ? "hb-c-agf-td" : ""}`} >
                                                                                                <span>
                                                                                                    {_.get(v, "AGF1", "")}
                                                                                                ({_.get(v, "AGFSIRA1", "")})
                                                                                            </span>

                                                                                            </div>
                                                                                        </div>
                                                                                        :
                                                                                        <div className="agf-graph">
                                                                                            <div className={`agf ${v.AGF2COLOR ? "hb-c-agf-td" : ""}`} >
                                                                                                <span>
                                                                                                    {_.get(v, "AGF2", "")}
                                                                                                ({_.get(v, "AGFSIRA2", "")})
                                                                                            </span>
                                                                                            </div>
                                                                                        </div>
                                                                                }
                                                                            </td>
                                                                            <td className="align-middle font-xxsm">
                                                                                {

                                                                                    // v.SON6HTML  // _.get(v, "SON6HTML", "")
                                                                                }


                                                                                {_.get(v, "SON6_ARR", []).map((v, i) => {
                                                                                    return (
                                                                                        <span key={i} style={{ fontWeight: 'bold', margin: '0 -1px' }}> {_.get(v, "text", "")}</span>
                                                                                    )
                                                                                })}


                                                                            </td>
                                                                            <td className="align-middle font-xxsm">{_.get(v, "START", "")}</td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-2 bet-coupon card show-coupon"
                                    style={{
                                        width: _.get(this.state.selectedBahis, "value", "") == "7_li_plase" ? 203 : undefined,
                                        paddingLeft: '0px', marginRight: '-15px', marginTop: '-25px', paddingRight: '0px'
                                    }}>
                                    <div className={`card-header bg-${this.selectedMinHourseInRuns() ? "success" : "glossred"} text-white p-1 transition-all-500`}>
                                        <div className="row no-gutters">
                                            <div className="col text-truncate" title="Bahis Türü">
                                                <span className="font-sm">
                                                    {
                                                        _.get(this.state.selectedBahis, "text", "")
                                                    }
                                                </span>
                                            </div>
                                            <div className="col-2">
                                                <div title="Bakiyeniz" className="text-right font-xxsm">
                                                    {
                                                        //_.get(this.props.UserStore.user, "balance", "")
                                                        // JSON.stringify(this.getSelectedDataBet())
                                                        //  _.get(this.state.selectedBahis, "children.text", "")
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col text-truncate" title="Yer">
                                                <span className="font-xxsm opacity-08">
                                                    {`${_.get(this.getSelectedData(), "hava.HIPODROMYERI", "")}`}
                                                </span>
                                            </div>
                                            <div className="col-2" />
                                        </div>
                                    </div>
                                    <div className="card-body p-1">
                                        <div className="bet-coupon-scrolled-body" style={{
                                            width: _.get(this.state.selectedBahis, "value", "") == "7_li_plase" ? 199 : undefined
                                        }}>
                                            <div data-selector="bet-content">
                                                <table data-selector="normalBetCheckboxs">
                                                    <thead>
                                                        <tr>

                                                            {
                                                                _.get(this.state.selectedBahis, "children.array", []).map((v, i) => {
                                                                    if (typeof v === "number") {
                                                                        v = v.toString()
                                                                    }
                                                                    return (
                                                                        <th key={i}
                                                                            //   className={`bg-black text-white pt-1 pb-1`}
                                                                            className={`bg-${_.get(_.find(_.get(this.getSelectedData(), "kosular", []), { NO: v }), "ActiveClass", "")} text-white pt-1 pb-1`}
                                                                        ><span>
                                                                                {i + 1}
                                                                            </span></th>
                                                                    )
                                                                })
                                                            }


                                                        </tr>
                                                        <tr>
                                                            {
                                                                _.get(this.state.selectedBahis, "children.array", []).map((v, i) => {
                                                                    return (
                                                                        <th key={i} >
                                                                            <button
                                                                                onClick={() => this.onClickHandikap(v, i)}
                                                                                // className={_.get(this.getSelectedKosu(),"NO")==v ? "selected" : ""}
                                                                                data-toggle="tooltip" title={`Tümünü seç: ${i + 1}.Koşu`}>
                                                                                H
                                          </button>
                                                                        </th>
                                                                    )
                                                                })
                                                            }

                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ zIndex: 20 }}>
                                                        <tr>
                                                            {cCouponItems}
                                                        </tr>
                                                    </tbody>
                                                </table>          </div>
                                            <div className="detail-box mb-1 d-none font-xsm" data-selector="couponDetails" />
                                        </div>
                                        <div className="custom-input-group mb-1" data-selector="multiplier">
                                            <div className="row no-gutters">
                                                <div className="col-3 pr-1">
                                                    <span className="font-xsm d-block text-right text-black-50 pt-1"><strong>Misli</strong></span>
                                                </div>
                                                <div className="col-4">
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-xs p-1 text-right"
                                                        min={1}
                                                        max={2500}
                                                        step={1}
                                                        onFocus={(e) => e.target.select()}
                                                        value={this.state.much}
                                                        onChange={(e) => this.setState({ much: e.target.value })}
                                                        //  defaultValue={1}
                                                        placeholder="Misli" />
                                                </div>
                                                <div className="col pl-1 pr-1">
                                                    <select
                                                        className="pmisli"
                                                        value={this.state.much}
                                                        onChange={(e) => this.setState({ much: e.target.value })}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={100}>100</option>
                                                        <option value={500}>500</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="custom-input-group mb-1 d-none" data-selector="amount">
                                            <div className="row no-gutters">
                                                <div className="col-3 pr-1">
                                                    <span className="font-xsm d-block text-right text-black-50 pt-1"><strong>Tutar</strong></span>
                                                </div>
                                                <div className="col-4">
                                                    <input type="number" className="form-control form-control-xs p-1 text-right" min={1} max={2500} step={1} defaultValue={5} placeholder="Tutar" />
                                                </div>
                                                <div className="col pt-1 pl-1">
                                                    <input type="range" className="custom-range" min={1} max={2500} step={1} defaultValue={5} data-option="amount" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="row no-gutters mb-1">
                                                <div className="col-12">
                                                    <div className="custom-input-group">
                                                        <span className="d-block font-xsm">Oran:
                                                        <strong>{this.betCount()}</strong></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="custom-input-group">
                                                <span className="d-block font-xsm">Tutar: <strong>
                                                    {this.getPrice()}₺
                                                    </strong></span>
                                            </div>
                                        </div>
                                        <div className="btn-group w-100 betCouponPlayButtonsGroup">
                                            <button
                                                onClick={(e) => this.onClickSaveCoupon()}
                                                className=""
                                                className={`btn btn-sm btn-danger transition-all-500 bg-${this.selectedMinHourseInRuns() ? "success" : "glossred"}`}
                                            >
                                                OYNA
                        </button>
                                            <button
                                                onClick={(e) => this.onClickClearCoupon()}
                                                className="btn btn-sm btn-danger btn-glossred border-left-dark-opaque transition-all-500"
                                            >
                                                Temizle
                                         </button>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </main>
                        {/* Bahiis Yap */}
                    </main>

                    <div style={{ display: "none" }}>
                        <ComponentToPrint type="coupon" state={this.state.coupon} ref={el => (this.componentRef = el)} />
                    </div>



                    <Modal
                        width="76%"

                        visible={this.state.modalVisible}
                        okText={"Tamam"}
                        cancelText={"Kapat"}
                        onCancel={(e) => this.onClickCancelModal()}
                        footer={<span><Button
                            onClick={() => this.onClickCancelModal()}
                            type="primary">Tamam</Button></span>}
                    >
                        {
                            this.state.hourseDetailHtml
                            &&
                            <Frame
                                frameBorder="0"
                                width="100%"
                                height="600px"
                                //   style={{ overflow: 'unset' }}
                                // initialContent={this.state.ic}
                                initialContent={`<!DOCTYPE html><html>
                                <head>
                                <style>
                                a.logo{
                                    display: none !important;
                                  }
                                

                                div.pane{
                                    display:block;
                                }
                                .footer-container, .footerText,.menu,.grid_11 relative,#nav,.i18n,img,.home,#totoform,.query,.dataat-tabs{
                                    display: none !important;
                                }
                                .container_24{
                                    background: unset !important;
                                }
                                .container_24 .pane{
                                    margin-left: -150px;
                                }
                                .tableTitle{
                                    color:#FFF;
                                    font-weight: bolder;
                                }
                                body{
                                    overflow-y:hidden;
                                }
                                  </style>
                                  <script>
                          
                                </script>

<script type="text/javascript">
/*
                                document.getElementsByTagName("a").removeAttribute("href");

	document.body.onclick =function(e){
        e.preventDefault();
    }

    var els = document.getElementsByTagName("a");

    Array.prototype.forEach.call(els, function(el) {
        // Do stuff here
       // console.log(el.tagName);
       el.onclick = null;

    });

    $('thead').click( function(e) {e.preventDefault(); alert("sddee") /*your_code_here;*/ return false; } );
                              

 */


</script>


                                </head>
                                <body>
                                ${this.state.hourseDetailHtml}<div id="mountHere"></div>
                                
                                <script>
                                $("a").attr("href", "#!");
                                $("a").attr("target", "_self");

                                $("a").click(function (e) {
                                    this.onclick = null;
                                  //  e.target.remove();
                                  //  e.preventDefault();
                                })
 
                               function postAjaxForm(){
                                    return;
                                }

</script>

                                </body></html>`}
                            >

                            </Frame>
                        }

                        {
                            this.state.jokeyDedailHtml
                            &&
                            <div>
                                <Frame
                                    frameBorder="0"
                                    width="100%"
                                    height="240px"
                                    //    style={{ overflow: 'unset' }}
                                    // initialContent={this.state.ic}
                                    initialContent={`<!DOCTYPE html><html>
                                <head>
                                <style>
                                a.logo{
                                    display: none !important;
                                  }
                                

                                div.pane{
                                    display:block;
                                }
                                .footer-container, .footerText,.menu,.grid_11 relative,#nav,.i18n,img,.home,#totoform,.query,.dataat-tabs{
                                    display: none !important;
                                }
                                .container_24{
                                    background: unset !important;
                                }
                                .container_24 .pane{
                                    margin-left: -150px;
                                }
                                .tableTitle{
                                    font-weight: bolder;
                                }
                                body{
                                    overflow-y:hidden;
                                    background: #e8e8e8 !important;
                                }
                                .tjk{
                                    background: #e8e8e8 !important;
                                }
                                  </style>
                                  <script>
                          
                                </script>

<script type="text/javascript">
/*
                                document.getElementsByTagName("a").removeAttribute("href");

	document.body.onclick =function(e){
        e.preventDefault();
    }

    var els = document.getElementsByTagName("a");

    Array.prototype.forEach.call(els, function(el) {
        // Do stuff here
       // console.log(el.tagName);
       el.onclick = null;

    });

    $('thead').click( function(e) {e.preventDefault(); alert("sddee") /*your_code_here;*/ return false; } );
                              

 */


</script>


                                </head>
                                <body>
                                ${this.state.jokeyDedailHtml}<div id="mountHere"></div>
                                
                                <script>
                                $("a").attr("href", "#!");
                                $("a").attr("target", "_self");

                                $("a").click(function (e) {
                                    this.onclick = null;
                                  //  e.target.remove();
                                  //  e.preventDefault();
                                })
 
                               function postAjaxForm(){
                                    return;
                                }

</script>

                                </body></html>`}
                                >

                                </Frame>
                            </div>
                        }

                    </Modal>



                </div>
            )
        }
        else {
            return (
                <>
                    <NavbarMenu />
                    <div style={{ padding: 50, fontSize: 50, textAlign: 'center', color: '#FFF', fontWeight: 800, border: '' }}>
                        Bahis Bulunmadı !
                </div>
                    <div style={{ padding: 20, fontSize: 20, textAlign: 'center', color: '#FFF', fontWeight: 600 }}>
                        <Link to="/program" style={{ border: '2px solid #f02', borderRadius: 10, padding: '0 20px' }}>
                            Programa göz at
                </Link>
                    </div>

                </>
            )
        }

    }
}